import { useCallback } from 'react';

import { type ViewFilters } from '@/types/schema/LiveAppView';
import { type ReportViewChart } from '@/types/schema/views/ReportView';

export function useChartFiltersHelpers() {
  const getPresetFilters = useCallback((chart: ReportViewChart) => {
    const allowsPresetFilters = chart.filters.allow_preset_filters;
    const filterType = chart.filters.filter_type;
    const shouldHavePresetFilters =
      allowsPresetFilters && filterType !== 'menu' && filterType !== 'none';

    if (!shouldHavePresetFilters) {
      return undefined;
    }

    const presetFilterCriteria = chart.filters.preset_filters;

    if (!presetFilterCriteria || presetFilterCriteria.length === 0) {
      return undefined;
    }

    const presetFilter: ViewFilters = {
      match: 'and',
      rules: presetFilterCriteria
    };

    return presetFilter;
  }, []);

  const getInitialMenuFilters = useCallback((chart: ReportViewChart) => {
    const filterType = chart.filters.filter_type;
    const shouldHaveMenuFilters = filterType === 'menu';

    if (!shouldHaveMenuFilters) {
      return undefined;
    }

    const menuFiltersRules = chart.filters.menu_filters;

    if (!menuFiltersRules || menuFiltersRules.length === 0) {
      return undefined;
    }

    // We only need the first menu filter rule, since that's the one that will be active by default
    const firstMenuFilterRule = menuFiltersRules[0];
    const menuFiltersFormatted: ViewFilters = {
      match: 'and',
      rules: [
        {
          field: firstMenuFilterRule.field,
          operator: firstMenuFilterRule.operator,
          value: firstMenuFilterRule.value
        }
      ]
    };

    return menuFiltersFormatted;
  }, []);

  return {
    getPresetFilters,
    getInitialMenuFilters
  };
}
